import React from 'react';
import { DiscussionEmbed } from 'disqus-react';
import Layout from '../../components/layout';
import MoneyPrediction from '../../components/calculators/MoneyPrediction';
import SEO from '../../components/seo';
import Box from '../../components/cardbox';
import Input from '../../components/Input';
import styles from './money_prediction.module.scss';
import Button from '../../components/Button';
import ExpectedExpense from "../../components/calculators/ExpenseInput";
import SalaryChange from "../../components/calculators/SalaryChange";

const disqusShortname = 'martinschnurer-net-1';


class MoneyPredictionPage extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      monthlySalary: 1000,
      monthlyExpenses: 700,
      startingPoint: 2000,
      salaryGrowth: 2,
      expensesGrowth: 2,
      predictForYears: 15,
      error: {},
      expectedExpenses: {},
      changedSalary: {},
      diversification: {
        cash: {
          growth: 0,
          share: 100,
        },
        bonds: {
          growth: 0.02,
          share: 0,
        },
        stocks: {
          growth: 0.06,
          share: 0,
          dividends: 0.01,
        }
      },
      retirementRule: null,
    };
  }

  changeMonthlySalary = e => this.setValueWithCheck('monthlySalary', e);
  changeMonthlyExpenses = e => this.setValueWithCheck('monthlyExpenses', e);
  changePredictYears = e => this.setValueWithCheck('predictForYears', e);
  changeStartingPoint = e => this.setValueWithCheck('startingPoint', e);

  changeSalaryGrowth = (e) => {
    const textValue = e.target.value;
    let value = textValue === "" ? 0 : parseFloat(textValue);

    if (Number.isNaN(value)) {
      return this.setState(state => ({ error: {
        ...state.error,
        salaryGrowth: true,
      }}));
    }
    const newObj = {...this.state};
    const errors = this.state.error;
    delete errors["salaryGrowth"];
    newObj.error = errors;
    newObj.salaryGrowth = textValue;
    this.setState(newObj);
  }

  changeExpensesGrowth = (e) => {
    const textValue = e.target.value;
    let value = textValue === "" ? 0 : parseFloat(textValue);

    if (Number.isNaN(value)) {
      return this.setState(state => ({ error: {
        ...state.error,
        expensesGrowth: true,
      }}));
    }
    const newObj = {...this.state};
    const errors = this.state.error;
    delete errors["expensesGrowth"];
    newObj.error = errors;
    newObj.expensesGrowth = textValue;
    this.setState(newObj);
  }

  addExpInput = () => {
    const { expectedExpenses } = this.state;
    const id = `
      ${Math.ceil(Math.random() * 100000)}
      ${Math.ceil(Math.random() * 100000)}
    `;
    const nowYear = new Date().getFullYear();

    this.setState({
      expectedExpenses: {
        ...expectedExpenses,
        [id]: {
          id,
          expense: 0,
          year: nowYear,
        },
      },
    });
  };

  addChangeSalaryInput = () => {
    const { changedSalary } = this.state;
    const id = `${Math.ceil(Math.random() * 100000)}${Math.ceil(Math.random() * 100000)}`;
    const nowYear = new Date().getFullYear();

    this.setState({
      changedSalary: {
        ...changedSalary,
        [id]: {
          id,
          salary: 0,
          year: nowYear,
        },
      },
    });
  }

  setValueWithCheck = (key, e) => {
    const { error } = this.state;
    const conversion = parseInt(e.target.value, 10);
    if (Number.isNaN(conversion)) {
      this.setState({ error: { ...error, [key]: true }, [key]: e.target.value });
    } else {
      const copy = { ...error };
      delete copy[key];
      this.setState({ error: copy, [key]: conversion });
    }
  }

  changeExpectedInputHandler = (id, year, expense) => {
    const { expectedExpenses } = this.state;
    this.setState({
      expectedExpenses: {
        ...expectedExpenses,
        [id]: {
          id,
          year,
          expense,
        },
      },
    });
  }

  deleteExpectedInputHandler = (id) => {
    const { expectedExpenses } = this.state;
    const newObj = { ...expectedExpenses };
    delete newObj[id];
    this.setState({ expectedExpenses: newObj });
  }

  salaryChangeDeleteHandler = (id) => {
    const { changedSalary } = this.state;
    const newObj = { ...changedSalary };
    delete newObj[id];
    this.setState({ changedSalary: newObj });
  }

  salaryChangeHandler = (id, year, salary) => {
    const { changedSalary } = this.state;
    this.setState({
      changedSalary: {
        ...changedSalary,
        [id]: {
          id,
          year,
          salary,
        },
      },
    });
  }

  setDiversification = (what, type, value) => {
    
    this.setState(state => {
      const oldObj = state.diversification;
      const newObj = { ...oldObj };
      
      if (type === "share") {
        value = parseInt(value, 10);
        const oldValue = oldObj[what][type];
        const difference = value - oldValue;
        const whatToChange = ["cash", "bonds", "stocks"].filter(s => s !== what);
        let remainingValue = Math.abs(difference);
        const partialSum = difference > 0 ? 1 : -1;
        
        let index = Math.floor(Math.random() * whatToChange.length);
        let safety_index = 0
      
        while (remainingValue > 0 && safety_index < 10000) {
          safety_index++;

          if (partialSum < 0 && newObj[whatToChange[index]].share >= 100) {
            index = (index + 1) % whatToChange.length;
            continue;
          }
          if (partialSum > 0 && newObj[whatToChange[index]].share <= 0) {
            index = (index + 1) % whatToChange.length;
            continue;
          }
          newObj[whatToChange[index]].share -= partialSum;
          remainingValue -= Math.abs(partialSum);
          index = (index + 1) % whatToChange.length;
        }
        
        newObj[what].share = value;
      } else {
        value = parseFloat(Math.round(value * 10000)) / 10000;
        newObj[what][type] = value;
      }

      return {
        diversification: newObj,
      }
    });
  }

  render() {
    const {
      startingPoint,
      monthlySalary,
      predictForYears,
      monthlyExpenses,
      error,
      expectedExpenses,
      salaryGrowth,
      expensesGrowth,
      changedSalary,
      diversification,
      retirementRule,
    } = this.state;
    return (
      <Layout withFooter={false}>
        <SEO
          title="Money Balance Calculator | FIRE Investments And Retirement Calculator"
          description="FIRE - retire early calculator. Let's compute your future money balance. Add your income, expenses, expected expenses and let's look what the future balance will look like."
          keywords={['money', 'calculator', 'expenses', 'income', 'future', 'fire', 'stocks']}
        />
        <Box>
          <div className="text-lg" style={{ marginTop: 20, marginBottom: 10 }}>
            This tool computes theoretical future money balance 
            based on the income, expenses, income growth and one-time expenses (Buy car, house, etc.).
            <br />It is also possible to play with investments thresholds and early retirement planning (FIRE).
          </div>
          <div style={{ paddingTop: 20, maxWidth: '100vw' }}>
            <div className={styles.input_grid}>
              <div>
                How much money do you actually have? (This is starting point)
              </div>
              <Input value={startingPoint} onChange={this.changeStartingPoint} />
            </div>

            <div className={styles.input_grid}>
              <div>Expected monthly salary (after tax)</div>
              <Input value={monthlySalary} onChange={this.changeMonthlySalary} />
            </div>

            <div className={styles.input_grid}>
              <div>Salary yearly growth (percent)</div>
              <Input value={salaryGrowth} onChange={this.changeSalaryGrowth} />
            </div>

            <div className={styles.input_grid}>
              <div>Monthly expenses</div>
              <Input value={monthlyExpenses} onChange={this.changeMonthlyExpenses} />
            </div>

            <div className={styles.input_grid}>
              <div>Expenses yearly growth (percent)</div>
              <Input value={expensesGrowth} onChange={this.changeExpensesGrowth} />
            </div>

            <div className={styles.input_grid}>
              <div>For how much years you want prediction to compute ?</div>
              <Input value={predictForYears} onChange={this.changePredictYears} />
            </div>

            <div style={{ overflowX: 'scroll' }}>
              <table>
                <tbody>
                  <tr><td colSpan={4}>Investments diversification (percent)</td></tr>
                  <tr>
                    <td />
                    <td className="text-center">% Diversity</td>
                    <td className="text-center">Growth</td>
                    <td className="text-center">% Dividends</td>
                  </tr>
                  <tr>
                    <td>Cash</td>
                    <td>
                      <div className={styles.tableTd}>
                        <span>{diversification.cash.share}</span>
                        <Input
                          type="range"
                          min={0}
                          max={100}
                          value={diversification.cash.share}
                          onChange={(e) => this.setDiversification("cash", "share", e.target.value)}
                        />
                      </div>
                    </td>
                    <td>
                      
                    </td>
                  </tr>
                  <tr>
                    <td>Bonds</td>
                    <td>
                      <div className={styles.tableTd}>
                        <span>{diversification.bonds.share}</span>
                        <Input
                          type="range"
                          min={0}
                          max={100}
                          value={diversification.bonds.share}
                          onChange={(e) => this.setDiversification("bonds", "share", e.target.value)}
                        />
                      </div>
                    </td>
                    <td>
                      <div className={styles.tableTd}>
                        <span>{Math.round(diversification.bonds.growth * 100 * 100)/100}%</span>
                        <Input
                          type="range"
                          min={-0.1}
                          step={0.005}
                          max={0.6}
                          value={diversification.bonds.growth}
                          onChange={(e) => this.setDiversification("bonds", "growth", e.target.value)}
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Stocks</td>
                    <td>
                      <div className={styles.tableTd}>
                        <span>{diversification.stocks.share}</span>
                        <Input
                          type="range"
                          min={0}
                          max={100}
                          value={diversification.stocks.share}
                          onChange={(e) => this.setDiversification("stocks", "share", e.target.value)}
                        />                   
                      </div>
                    </td>
                    <td>
                      <div className={styles.tableTd}>
                        <span>{Math.round(diversification.stocks.growth * 100 * 100) / 100}%</span>
                        <Input
                          type="range"
                          min={-0.1}
                          max={0.6}
                          step={0.005}
                          value={diversification.stocks.growth}
                          onChange={(e) => this.setDiversification("stocks", "growth", e.target.value)}
                        />
                      </div>
                    </td>
                    <td>
                      <div className={styles.tableTd}>
                        <span>{Math.round(diversification.stocks.dividends * 100 * 100) / 100}%</span>
                        <Input
                          type="range"
                          min={0}
                          max={0.1}
                          step={0.001}
                          value={diversification.stocks.dividends}
                          onChange={(e) => this.setDiversification("stocks", "dividends", e.target.value)}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

           

            <div className={styles.labelAdditional}>
              <div>Salary changes in future</div>
              <div className={styles.note}>Unexpectedly higher promotion, lose of job, set salary to retirement support.</div>
            </div>


            <div style={{ marginBottom: 15 }}>
              {Object.entries(changedSalary).map(([id, obj]) => (
                <SalaryChange
                  id={id}
                  minYear={new Date().getFullYear()}
                  maxYear={new Date().getFullYear() + predictForYears}
                  key={id}
                  year={obj.year}
                  salary={obj.salary}
                  onDelete={this.salaryChangeDeleteHandler}
                  onChange={this.salaryChangeHandler}
                />
              ))}
              <Button type="button" className="py-2 px-4" onClick={this.addChangeSalaryInput}>Add Salary Change</Button>
            </div>

            <hr />
            
            <div className={styles.labelAdditional}>
              <div>One-time expenses</div>
              <div className={styles.note}>Note that you can also map one-time financial gain, for example inheritance, win lottery and so on with negative number (negative expense). For example -10 000</div>
            </div>

            <div style={{ marginBottom: 15 }}>
              {Object.entries(expectedExpenses).map(([id, obj]) => (
                <ExpectedExpense
                  id={id}
                  minYear={new Date().getFullYear()}
                  maxYear={new Date().getFullYear() + predictForYears}
                  key={id}
                  year={obj.year}
                  expense={obj.expense}
                  onDelete={this.deleteExpectedInputHandler}
                  onChange={this.changeExpectedInputHandler}
                />
              ))}
              <Button type="button" className="py-2 px-4" onClick={this.addExpInput}>Add expense</Button>
            </div>

            <hr />
            
            <div style={{ marginTop: 20, marginBottom: 20 }}>
                Retire early
                {' '}<input 
                  type="checkbox"
                  checked={retirementRule !== null} 
                  onChange={e => this.setState({ retirementRule: e.target.checked ? ({
                    inYear: Math.round(new Date().getFullYear() + 5),
                    percents: 0.04,
                  }) : null})}
                />
                <div>
                  When the retirement year come, investing to bonds and stocks will be stopped, you're going to
                  withdraw % of your money from stocks. Read more on <a href="https://www.investopedia.com/terms/f/four-percent-rule.asp" target="_blank">4% rule</a>.
                </div>
                {
                  retirementRule !== null && (
                    <div>
                      <div className={styles.retirementRow}>
                        <div>Retire in year</div>
                        <div>
                          <div className="text-center">{retirementRule.inYear}</div>
                            <Input
                              type="range"
                              min={new Date().getFullYear() + 1}
                              max={new Date().getFullYear() + predictForYears}
                              value={retirementRule.inYear}
                              onChange={e => this.setState({ retirementRule: {
                                ...this.state.retirementRule,
                                inYear: +e.target.value
                              }})}
                            />
                        </div>
                      </div>
                      <div className={styles.retirementRow}>
                        <div>Withdraw from stocks % every year</div>
                        <div>
                          <div className="text-center">{Math.round(retirementRule.percents * 100)}%</div>
                            <Input
                              type="range"
                              min={0}
                              step={0.0005}
                              max={1}
                              value={retirementRule.percents}
                              onChange={e => this.setState({ retirementRule: {
                                ...this.state.retirementRule,
                                percents: +e.target.value
                              }})}
                            />
                        </div>
                      </div>
                    </div>
                  )
                }
            </div>

            <hr />

            <div style={{ paddingTop: 20 }}>
              {
                Object.keys(error).length === 0 && (
                  <MoneyPrediction
                    salaryYearlyGrowth={1 + (parseFloat(salaryGrowth || 0) / 100)}
                    monthSalary={monthlySalary}
                    monthExpenses={monthlyExpenses}
                    expensesYearlyGrowth={1 + (parseFloat(expensesGrowth || 0) / 100)}
                    startingPoint={startingPoint}
                    time={predictForYears}
                    theoreticalExpenses={Object.values(expectedExpenses).reduce((acc, val) => {
                      acc[val.year] = acc[val.year] === undefined
                        ? +val.expense : (+acc[val.year] + (+val.expense));
                      return acc;
                    }, {})}
                    changedSalary={Object.values(changedSalary).reduce((acc, val) => {
                      acc[val.year] = acc[val.year] === undefined
                        ? +val.salary : (+acc[val.year] + (+val.salary));
                      return acc;
                    }, {})}
                    portfolioDiversity={diversification}
                    retirementRule={retirementRule}
                  />
                )
              }
            </div>
          </div>
          <div>
            <h2>Hey! Feature request, ideas or found bugs? <br/>Write me down.</h2>
            <DiscussionEmbedded />
          </div>
        </Box>
      </Layout>
    );
  }
}

const DiscussionEmbedded = React.memo(() => (
  <DiscussionEmbed
    shortname={disqusShortname}
    config={{
      identifier: "calculator-money-prediction",
      title: "Money balance prediction",
    }}
  />
))

export default MoneyPredictionPage;
